module.exports = __webpack_public_path__ + "static/media/main idea.5c73e31c.mp3";